import { Component, Input } from "@angular/core";
import { getApp } from "../app";
import { model2Doc, saveMessage } from "../api.service";
import { ActivatedRoute } from "@angular/router";
import { Message } from "../../../../shared/models/message";

@Component({
  selector: "app-message",
  templateUrl: "./message.component.html",
  styleUrls: ["./message.component.scss"],
})
export class MessageComponent {
  app = getApp((app) => {
    this.app = app;
  });

  @Input() id: string | null = null;
  @Input() type = "";
  @Input() showMessages = true;

  saveAttempted = false;
  constructor(private route: ActivatedRoute) {}
  ngOnInit() {
    // reset the model if id is null
    if (this.id == null) {
      this.app.message.model = {} as Message;
    }

    this.route.params.subscribe((params) => {
      if (params.partNumber) {
        this.app.message.entityId = params.partNumber;
      }
      if (params.manufacturerId) {
        this.app.message.entityId = params.manufacturerId;
      }
    });
  }

  showSaveButton(messageId: string | null) {
    if (this.app.unlockedId) {
      if (
        this.app.field.getInvalidFields("message", this.app.message.model)
          .length < 1 &&
        this.app.message.modelHasChanges(messageId)
      ) {
        return true;
      }
    } else {
      if (
        this.app.field.getInvalidFields("message", this.app.message.model)
          .length < 1
      ) {
        return true;
      } else {
        return false;
      }
    }
  }

  togglePost() {
    this.showMessages = !this.showMessages;
  }

  async save() {
    this.saveAttempted = true;
    const customer = this.app.customers.expectCurrent;

    let doc: any = {} as Message;
    doc = model2Doc("message", this.app.message.model);
    doc.entityId = this.app.message.entityId;
    doc.type = "message";
    doc.create_user_id = this.app.state.userId;
    doc.update_user_id = this.app.state.user_id;
    await saveMessage(customer, doc);
    this.app.message.clearModel();
    this.app.unlockedId = null;
    this.saveAttempted = false;
    if (this.app.message.entityId != null) {
      this.app.message.getMessages(this.app.message.entityId);
    }
  }
}
